import React, { Component } from 'react'

class Screen5 extends Component {

  render() {

      const { entry, addEntry, language, t } = this.props

      const forms = [t(language, 'incident'), t(language, 'socialMedia'), t(language, 'media'), t(language, 'publicArea'), t(language, 'publicGathering')]

      let form = ''

      switch (entry.form) {
        case forms[0]:
          form = <div>
            <p style={{marginBottom: 65}}>{t(language, 'socialMediaDetails')}</p>
            <label>{t(language, 'incidentDateTime')}
              <input type="text" value={entry.time} onChange={(e) => addEntry('time', null, e)} />
            </label>
            <label>{t(language, 'incidentType')}
              <select value={entry.sport_type} onChange={(e) => addEntry('sport_type', null, e)}>
                <option></option>
                <option>{t(language, 'symbolRequisite')}</option>
                <option>{t(language, 'acceptableChanting')}</option>
              </select>
            </label>
          </div>
          break;
        case forms[1]:
          form =<div>
            <p style={{marginBottom: 65}}>{t(language, 'socialMediaDetails')}</p>
            <label>{t(language, 'socialNetwork')}
            <select value={entry.network} onChange={(e) => addEntry('network', null, e)}>
              <option></option>
              <option>Facebook</option>
              <option>Twitter</option>
              <option>Instagram</option>
              <option>Youtube</option>
              <option>Google+</option>
              <option>Snapchat</option>
              <option>Dailymotion</option>
              <option>jeuxvideo.com</option>
              <option>{language === 'hr' ? 'neka druga društvena mreža' : 'some other social network'}</option>
            </select>
            </label>
            <label>{t(language, 'basis')}
              <select value={entry.network_type} onChange={(e) => addEntry('network_type', null, e)}>
                <option></option>
                <option>{t(language, 'nationality')}</option>
                <option>{t(language, 'gender')}</option>
                <option>{t(language, 'language')}</option>
                <option>{t(language, 'religion')}</option>
                <option>{t(language, 'sexualOrientation')}</option>
                <option>{t(language, 'skinColor')}</option>
                <option>{t(language, 'refugeeStatus')}</option>
                <option>{t(language, 'age')}</option>
                <option>{t(language, 'healthDisability')}</option>
                <option>{t(language, 'maritalStatus')}</option>
                <option>{t(language, 'education')}</option>
              </select>
            </label>
            <label>{t(language, 'url')}
              <input type="text" value={entry.url} onChange={(e) => addEntry('url', null, e)} placeholder={t(language, 'urlPlaceholder')} />
            </label>
          </div>
          break;
        case forms[2]:
          form = <div>
            <p style={{marginBottom: 15}}>{t(language, 'socialMediaDetails')}</p>
            <label>{t(language, 'mediaSource')}
              <select value={entry.media_source} onChange={(e) => addEntry('media_source', null, e)}>
                <option></option>
                <option>{t(language, 'tv')}</option>
                <option>{t(language, 'radio')}</option>
                <option>{t(language, 'printMedia')}</option>
                <option>{t(language, 'internetPortal')}</option>
                <option>{t(language, 'forum')}</option>
                <option>{t(language, 'otherWebsite')}</option>
            </select>
            </label>
            <label>{t(language, 'mediaName')}
              <input type="text" value={entry.media_name} onChange={(e) => addEntry('media_name', null, e)} />
            </label>
            <label>{t(language, 'basis')}
              <select value={entry.media_type} onChange={(e) => addEntry('media_type', null, e)}>
                <option></option>
                <option>{t(language, 'nationality')}</option>
                <option>{t(language, 'gender')}</option>
                <option>{t(language, 'language')}</option>
                <option>{t(language, 'religion')}</option>
                <option>{t(language, 'sexualOrientation')}</option>
                <option>{t(language, 'skinColor')}</option>
                <option>{t(language, 'refugeeStatus')}</option>
                <option>{t(language, 'age')}</option>
                <option>{t(language, 'healthDisability')}</option>
                <option>{t(language, 'maritalStatus')}</option>
                <option>{t(language, 'education')}</option>
              </select>
            </label>
          </div>
          break;
        case forms[3]:
          form = <div>
            <p style={{marginBottom: 15}}>{t(language, 'publicMarkings')}</p>
            <label>{t(language, 'markingType')}
              <select value={entry.public_object} onChange={(e) => addEntry('public_object', null, e)}>
                <option></option>
                <option value={t(language, 'graffiti')}>{t(language, 'graffiti')}</option>
                <option value={t(language, 'hatefulSymbol')}>{t(language, 'hatefulSymbol')}</option>
                <option value={t(language, 'poster')}>{t(language, 'poster')}</option>
                <option value={t(language, 'advertisement')}>{t(language, 'advertisement')}</option>
                <option value={t(language, 'defacement')}>{t(language, 'defacement')}</option>
            </select>
            </label>
            <label>{t(language, 'publicLocation')}
              <input type="text" value={entry.public_place} onChange={(e) => addEntry('public_place', null, e)} />
            </label>
            <label>{t(language, 'basis')}
              <select value={entry.public_type} onChange={(e) => addEntry('public_type', null, e)}>
                <option></option>
                <option>{t(language, 'nationality')}</option>
                <option>{t(language, 'gender')}</option>
                <option>{t(language, 'language')}</option>
                <option>{t(language, 'religion')}</option>
                <option>{t(language, 'sexualOrientation')}</option>
                <option>{t(language, 'skinColor')}</option>
                <option>{t(language, 'refugeeStatus')}</option>
                <option>{t(language, 'age')}</option>
                <option>{t(language, 'healthDisability')}</option>
                <option>{t(language, 'maritalStatus')}</option>
                <option>{t(language, 'education')}</option>
              </select>
            </label>
          </div>
          break;
        case forms[4]:
          form = <div>
            <p style={{marginBottom: 15}}>{t(language, 'publicGatheringDetails')}</p>
            <label>{t(language, 'gatheringType')}
              <select value={entry.meeting_object} onChange={(e) => addEntry('meeting_object', null, e)}>
                <option></option>
                <option>{t(language, 'protest')}</option>
                <option>{t(language, 'concert')}</option>
                <option>{t(language, 'publicEvent')}</option>
                <option>{t(language, 'other')}</option>
            </select>
            </label>
            <label>{t(language, 'gatheringLocation')}
              <input type="text" value={entry.meeting_place} onChange={(e) => addEntry('meeting_place', null, e)} />
            </label>
            <label>{t(language, 'basis')}
              <select value={entry.meeting_type} onChange={(e) => addEntry('meeting_type', null, e)}>
                <option></option>
                <option>{t(language, 'nationality')}</option>
                <option>{t(language, 'gender')}</option>
                <option>{t(language, 'language')}</option>
                <option>{t(language, 'religion')}</option>
                <option>{t(language, 'sexualOrientation')}</option>
                <option>{t(language, 'skinColor')}</option>
                <option>{t(language, 'refugeeStatus')}</option>
                <option>{t(language, 'age')}</option>
                <option>{t(language, 'healthDisability')}</option>
                <option>{t(language, 'maritalStatus')}</option>
                <option>{t(language, 'education')}</option>
              </select>
            </label>
          </div>
          break;
        default:
          form = null
      }


    return (
      <main>
        <h3>{entry.form}</h3>
        {form}
      </main>
    );
  }
}

export default Screen5;
